/*
 * MDB shim for MDBTableBody
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx 
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx 
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx 
 * - src/Seating/Reports/dailyOrderCounts.jsx 
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx 
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/trainingLink.js
 */

import MUITableBody from "@mui/material/TableBody";
import MUITableRow from "@mui/material/TableRow";
import MUITableCell from "@mui/material/TableCell";

export default function MDBTableBody({ children, rows, columns, ...rest }) {


    if (children) {
        return <MUITableBody {...rest}>{children}</MUITableBody>;
    }

    if (rows.length > 0 && (!columns || columns.length === 0)) {
        return (
            <MUITableBody {...rest}>
                {rows.map((row, rowIndex) => (
                    <MUITableRow key={row.id || `row-${rowIndex}`} onClick={row.clickEvent}>
                        {Object.values(row).map((cellValue, cellIndex) => (
                            <MUITableCell key={cellIndex} sx={{ textAlign: "center" }}>{cellValue}</MUITableCell>
                        ))}
                    </MUITableRow>))}
            </MUITableBody>

        )
    }

    return (
        <MUITableBody {...rest}>{
            rows.map((row, rowIndex) => (
                <MUITableRow key={row.id || `row-${rowIndex}`} onClick={row.clickEvent}>
                    {columns.map((column, columnIndex) => (<MUITableCell key={`${row.id || rowIndex}-${column.field || columnIndex}`} sx={{ textAlign: "center" }}>{row[column.field]}</MUITableCell>))}
                </MUITableRow>
            ))}
        </MUITableBody>
    )

}
